<template>
    <div class="passwordBlock">
        <input :type="type" v-model="input" class="wideField password" :disabled="props.isPropsPasswordInputDisabled" autocomplete="new-password" />
        <button type="button" class="btnPassword" @click="change" :disabled="props.isPropsPasswordInputDisabled">&nbsp;</button>
    </div>
</template>

<style></style>

<script setup>
    import { defineModel, ref } from 'vue';
    import { defineProps } from 'vue';
    import { defineExpose } from 'vue';

    const INPUT_TYPE_TEXT = 'text';
    const INPUT_TYPE_PASSWORD = 'password';

    const input = defineModel('input');
    const type = ref(INPUT_TYPE_PASSWORD);

    /**
     * 親画面から実行を許可する本コンポーネント内のメソッドの一覧。
     */
    defineExpose({
        resetInput,
    });

    // InputのHTML要素を初期化する。
    async function resetInput() {
        // パスワード入力欄のHTMLの型の初期値はpassword型にする。
        type.value = INPUT_TYPE_PASSWORD;
    }

    function change() {
        if (type.value === INPUT_TYPE_PASSWORD) {
            type.value = INPUT_TYPE_TEXT;
        } else {
            type.value = INPUT_TYPE_PASSWORD;
        }
    }

    const props = defineProps({
        isPropsPasswordInputDisabled: {
            type: Boolean,
            default: false,
            required: true,
        },
    });
</script>
